module.exports = __webpack_public_path__ + "img/story6.f1c57103.webp";